import {
  Component,
  inject,
  Renderer2,
  signal,
  TemplateRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DesktopSidebarComponent } from '../../../shared/ui/layout/desktop-sidebar/desktop-sidebar.component';

import { AsideService } from '../../services/aside.service';
import { PageContextService } from './../../services/page-context.service';
import { NgTemplateOutlet, NgComponentOutlet } from '@angular/common';
import { AsideContentComponent } from '../../../shared/ui/layout/aside-content/aside-content.component';
import { ButtonComponent } from '../../../shared/ui/button/button.component';
import { HeadingComponent } from '../../../shared/ui/typography/heading/heading.component';
import { AssistantWidgetComponent } from '../../../shared/ui/assistant/assistant-widget.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { ToastComponent } from '../../../shared/ui/toast/toast.component';

@Component({
  selector: 'app-laptop-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    DesktopSidebarComponent,
    NgTemplateOutlet,
    NgComponentOutlet,
    AsideContentComponent,
    ButtonComponent,
    HeadingComponent,
    ToastComponent,
    AssistantWidgetComponent],
  templateUrl: './laptop-layout.component.html',
  styleUrl: './laptop-layout.component.css',
})
export class LaptopLayoutComponent {
  protected readonly featureFlags = inject(FeatureFlagService);
  asideService = inject(AsideService);
  pageContextService = inject(PageContextService);
  private readonly renderer = inject(Renderer2);

  sidebarCollapsed = signal(true); // Collapsed by default on laptop

  // --- Aside Resizing Logic ---
  asideWidth = signal(350); // Default width
  private onResizeMove!: () => void;
  private onResizeEnd!: () => void;

  onResizeStart(event: MouseEvent): void {
    event.preventDefault();
    const initialX = event.clientX;
    const initialWidth = this.asideWidth();

    this.onResizeMove = this.renderer.listen(
      'document',
      'mousemove',
      (moveEvent: MouseEvent) => {
        const deltaX = moveEvent.clientX - initialX;
        let newWidth = initialWidth - deltaX;
        // Enforce min and max width
        if (newWidth < 320) newWidth = 320;
        if (newWidth > 450) newWidth = 450;
        this.asideWidth.set(newWidth);
      }
    );

    this.onResizeEnd = this.renderer.listen('document', 'mouseup', () => {
      this.onResizeMove(); // Cleanup mousemove listener
      this.onResizeEnd(); // Cleanup mouseup listener
    });
  }

  isTemplateRef(content: any): content is TemplateRef<any> {
    return content instanceof TemplateRef;
  }
}
